export default __webpack_public_path__ + "b315340262f00f9457ff4d490127ec76.svg";